<!--jzxz.vue  就诊须知-->
<template>
  <div class="jszlcjpdlc-box">
    <div class="title">
      <h2>苏州市广济医院</h2>
      <h3>精神、智力残疾评定流程</h3>
    </div>

    <div class="flow-chart">
      <div v-for="(item, index) in flowList" :key="index" class="flow-item">
        <div class="content">{{ item }}</div>
        <div v-if="index !== flowList.length - 1" class="arrow">
          <van-icon name="down" />
        </div>
      </div>
    </div>

    <div class="notice">
      门诊时间: 请关注苏州市广济医院微信公号→就医服务→预约挂号→精神、智力残疾评定门诊
    </div>
  </div>
</template>

<script>
export default {
  name: 'Jszlcjpdlc',
  data() {
    return {
      flowList: [
        '监护人向所属社区申请',
        '准备申请表、评定表、相关病历、康复训练证明等资料',
        '预约残疾评定门诊',
        '门诊取号',
        '递交材料、专家评定',
        '缴费',
        '检查',
        '递交检查报告单',
        '专家综合评估后离院'
      ]
    }
  },
  created() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.jszlcjpdlc-box {
  padding: 10px 20px;
  background-color: #fff;

  .title {
    text-align: center;
    margin-bottom: 30px;

    h2 {
      font-size: 24px;
      margin-bottom: 10px;
    }

    h3 {
      font-size: 20px;
    }
  }

  .flow-chart {
    width: 80%;
    margin: 0 auto;

    .flow-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .content {
        background: #fff;
        border: 1px solid #409EFF;
        color: #409EFF;
        padding: 6px 20px;
        border-radius: 8px;
        min-width: 200px;
        text-align: center;
        font-size: 14px;
        line-height: 22px;
      }

      .arrow {
        color: #409EFF;
        font-size: 20px;
        margin: 4px 0;
      }
    }
  }

  .notice {
    margin-top: 30px;
    text-align: center;
    color: #666;
    font-size: 14px;
    line-height: 1.5;
    padding-bottom: 20px;
  }
}
</style>
